import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuex from 'vuex'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import ElementLang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import axios from './http'
import lang from './lang'
import Global from './global'
import api from './http/api.js'
import appHttp from './app/http'
import VueClipboard from 'vue-clipboard2'

if (localStorage.getItem('language') !== 'zh-cn') {
  locale.use(ElementLang)
}

Vue.prototype._global = Global
Vue.prototype.$http = axios
Vue.prototype.$app = appHttp
Vue.prototype.$api = api
Vue.prototype.$lang = lang
Vue.config.productionTip = false
Vue.use(ElementUI, Vuex)
Vue.use(VueClipboard)

window.changeLang = (val) => {
  if (val === 'zh-cn') {
    var lang = 'zh-cn'
  } else {
    lang = 'en'
  }
  if (localStorage.getItem('langSet') !== lang) {
    if (localStorage.getItem('token')) {
      let params = {
        language: lang,
        time_zone: Global.config.timezone,
      }
      api.changeTimezone(params)
    }
    localStorage.setItem('langSet', lang)
    setTimeout(() => {
      window.location.reload()
    }, 300)
  }
}
let vueObject = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default vueObject
